/**
 * @title costcopay-account-information.js: Sub module for Account pages
 * @description: This modules is used to perform many of the action that a user can partake
 * to manage their costco pay account information.
 * The capability include
 * 		Registering for Costco Pay
 * 		Adding/Editing the saved payment information
 * 		Removing their saved payment method
 */
define(['ajaxmodular','creditcard'], function(ajaxModular, creditCard) {
	let CostcoPayAccountInformation = {
		sessionId: '',
		authToken: '',
		/**
		 * Return the active CostcoPay Payment method form 
		 */
		getPaymentMethodForm: function() {
			return $('#CostcoPayPaymentMethodForm');
		},
		/**
		 * Function used to get the current user's costcoPayUserId
		 * the data is stored in 2 possible location it can be either in the
		 * costcoPayPaymentObject if there is a valid payment method or a hidden input
		 * in the form when the user is registered however has no valid payment method
		 */
		getCostcoPayUserId: function() {
			if(typeof costcoPayPaymentObject !== 'undefined')
				return costcoPayPaymentObject.costcoPayUserId;
			else if(typeof CostcoPayAccountInformation.getPaymentMethodForm() !== 'undefined')
				return CostcoPayAccountInformation.getPaymentMethodForm().find('[name=costcoPayUserId]').val();
		},
		/**
		 * If the user does not have a linked membership the jsp will render the add membership form
		 */
		hasCostcoPayMembership: function() {
			return $('#AddMembershipForm').length == 0;
		},
		/**
		 * Check to see if the user has a valid payment method
		 */
		hasPaymentMethod: function() {
			let eprAccountUserId = '';
			let eprPaymentAccountId = '';
			let costcoPayReset = '';
			if(this.getPaymentMethodForm().length > 0) {
				eprAccountUserId = this.getPaymentMethodForm().find('[name=eprAccountUserId]').val()
				eprPaymentAccountId = this.getPaymentMethodForm().find('[name=eprPaymentAccountId]').val();
				costcoPayReset = this.getPaymentMethodForm().find('[name=costcoPayReset]').val();
			}
			else {
				eprAccountUserId = costcoPayPaymentObject.eprAccountUserId;
				eprPaymentAccountId = costcoPayPaymentObject.eprPaymentAccountId;
			}
			
			if(eprAccountUserId!== '' && eprPaymentAccountId !== '' && costcoPayReset!=='true') {
				return true;
			}
			
			return false;
		},
		init: function() {
			COSTCO.util.accesible_popover($('.co-info, .co-help'));
			this.maskInput();
			this.validationRules();
			this.authToken = $('[name=authToken]').val();
			
			if($('#linked-membership-number-form').length > 0) {
				COSTCO.AccountDetails.linkedMembershipFormHandler();
				
				$('#buy-membership-button').unbind('click').bind('click', function() {
			        if ($.cookie('cartCountCookie') > 0) {
			          window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
			        } else {
			          window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
			        }
			     });
			}
			if(typeof CostcoPayAccountInformation.getCostcoPayUserId() !== 'undefined' && CostcoPayAccountInformation.getCostcoPayUserId()!== "") {
				$('#navigation-tabs').show();
			}
			else {
				$('#navigation-tabs').hide();
			}
			
			console.log('CostcoPayFob-Payment module initiated');
		},
		/**
		 * Function to mask the input of the payment method form
		 */
		maskInput: function() {
	      $('#cc_expiry_date').mask('00/00', {
	        placeholder: '__/__',
	      });
	      $('#card_number').mask('ZZZZ ZZZZ ZZZZ 0000', {
	        selectOnFocus: true,
	        translation: {
	          'Z': {
	            pattern: '[\\*0-9]',
	          },
	        },
	      });
	    },
	    /**
	     * Function used to validate credit card form
	     */
	    validationRules: function() {
	    	//Call on CreditCard module to lay down initial business rules
	    	COSTCO.CreditCard.validationRules();
	    	
	    	//Costco Pay only allow VISA and co-branded card
	    	$.validator.addMethod('checkCardType', function(value,element){
	    		let ccNum = (value + '').replace(/\s/g, ''); //remove space
	    		
	    		let cardType = COSTCO.CreditCard.getCardType(ccNum);
	    		if(cardType != COSTCO.CreditCard.cardTypes.DEFAULT_PAYMENT){
	    			
	    			if(cardType != COSTCO.CreditCard.cardTypes.VISA && 
	    			   cardType != COSTCO.CreditCard.cardTypes.COSTCO_CREDIT_CARD) {
	    				return false;
	    	    	}
	    		}
	    		return true;
	    	});
	    },
	    /**
	     * Validates the Payment Methods add/edit form
	     * Standard CC validation here in terms of name on card, cc number, and expiration date
	     * Additional validation that it can only be VISA card
	     * @return {void}
	     */
	    validateCostcoPayPaymentForm: function() {
	      let form = CostcoPayAccountInformation.getPaymentMethodForm();
	      form.validate({
	        rules: {
	          number: {
	            required: true,
	            customcc: true,
	            checkCardType: true
	          },
	          cc_nameoncard: {
	        	required: true,
	            checkSpecialchar: true,
	          },
	          cc_expiry_date: {
	            required: true,
	            checkExpiryDate: true,
	            checkIsDateInPast: true,
	          }
	        },
	        messages: {
	          number: {
	            required: messages.ERR_COSTCO_PAY_REQUIRED_CARD_NUMBER,
	            customcc: messages.ERR_COSTCO_PAY_INVALID_CARD_NUMBER,
	            checkCardType: messages.ERR_COSTCO_PAY_INVALID_CARD_TYPE
	          },
	          cc_nameoncard: {
	        	required: messages.ERR_COSTCO_PAY_REQUIRED_NAME_ON_CARD,
	            checkSpecialchar: messages.ERR_COSTCO_PAY_INVALID_NAME_ON_CARD,
	          },
	          cc_expiry_date: {
	            required: messages.ERR_COSTCO_PAY_REQUIRED_EXP_DATE,
	            checkExpiryDate: messages.ERR_COSTCO_PAY_INVALID_EXP_DATE,
	            checkIsDateInPast: messages.ERR_COSTCO_PAY_PAST_EXP_DATE,
	          }
	        },
	        errorPlacement: function(error, element) {
	          if (element.is('#card_number_validator')) {
	            $('.gw-proxy-number').css('border', '');
	            $('.gw-proxy-number').addClass('card-number-error');
	            error.insertAfter(element);
	          } 
	          else {
	            error.insertAfter(element);
	          }
	        },
	      });

	      if (form.length != 0) {
	        return form.valid();
	      }
	    },
	    /**
	     * Helper function used to prepare the payment form data and
	     * send the payment method update to the AjaxManageCostcoPayPaymentCmd
	     * Primarily this is used when user want to update their CC and remove their CC
	     */
	    ajaxManageCostcoPayPayment: function() {
	    	 let form = CostcoPayAccountInformation.getPaymentMethodForm();
	    	 let expDate = $(form).find('input[name=cc_expiry_date]').val().split('/');

	         $(form).find('input[name=expireMonth]').val(expDate[0]);
	         $(form).find('input[name=expireYear]').val('20' + expDate[1]);
	         
	         $('#costco-pay-payment-method').addClass('ajax-busy');
	         let formData = COSTCO.util.objectifyArray(form.serializeArray());
	         
	    	 if(CostcoPayAccountInformation.validateCostcoPayPaymentForm()) {
	    		 ajaxModular.ajax_update_state({
	     	        method: 'POST',
	     	        url: '/AjaxManageCostcoPayPaymentCmd',
	     	        data: formData,
	     	        dataType: 'json',
	     	        done: function (data, textStatus, jqXHR, options) {
	     	        	if(!data.errorMessage) {
	     	        		ajaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
	     	        		if(typeof CostcoPayAccountInformation.getCostcoPayUserId() !== 'undefined') {
	    	     	        	COSTCO.CostcoPayFob.getCostcoPayFobs();
	    	     	        }
	     	        		COSTCO.util.accesible_popover($('.co-info, .co-help'));
	     	        	}
	     	        	else {
	     	        		let errorCont = $(form).find('.critical-notification');
	     	        		errorCont.text(data.errorMessage);
	     	        		errorCont.removeClass('hide');
	     	        	}
	     	        },
	     	        always: function() {
	     	            $('#costco-pay-payment-method').removeClass('ajax-busy');
	     	            TokenGateway.refreshGateway();
	     	        },
	 	    	 }); 
	    	 }
	    	 else {
	    		$('#costco-pay-payment-method').removeClass('ajax-busy');
	    	 }
	    },
	    /**
	     * Function to invoke the registation end poit so new user can register
	     * for a costcopay fob
	     */
	    ajaxRegisterCostcoPayUser: function () {
	    	$('#costco-pay-payment-method').addClass('ajax-busy');
    		$('#costco-pay-notification').addClass('ajax-busy');
    		
	    	let paymentForm = CostcoPayAccountInformation.getPaymentMethodForm();
	    	
	    	let paymentData = {};
	    	
	    	//Check if the payment form exist, which mean we need to take the values from the form
	    	//if not user is registering with card on file so use that
	    	if(paymentForm.length > 0) {
	    		let expDate = $(paymentForm).find('input[name=cc_expiry_date]').val().split('/');
		    	$(paymentForm).find('input[name=expireMonth]').val(expDate[0]);
		    	$(paymentForm).find('input[name=expireYear]').val('20' + expDate[1]);
		    	if(CostcoPayAccountInformation.validateCostcoPayPaymentForm()) {
		    		paymentData = paymentForm.serializeArray();
		    	}
		    	else {
		    		 $('#costco-pay-payment-method').removeClass('ajax-busy');
	     	         $('#costco-pay-notification').removeClass('ajax-busy');
		    	}
	    	}
	    	else {
	    		paymentData.tokenSessionId = costcoPayPaymentObject.tokenSessionId;
	    		paymentData.authToken = costcoPayPaymentObject.authToken;
	    		paymentData.eprAccountUserId = costcoPayPaymentObject.eprAccountUserId;
	    		paymentData.eprPaymentAccountId = costcoPayPaymentObject.eprPaymentAccountId;
	    		paymentData.cardType = costcoPayPaymentObject.cardType;
	    		paymentData.number = costcoPayPaymentObject.cardNumber;
	    		paymentData.cc_nameoncard = costcoPayPaymentObject.cardHolderName;
	    		paymentData.expireMonth = costcoPayPaymentObject.cardExpireMonth;
	    		paymentData.expireYear = '20'+costcoPayPaymentObject.cardExpireYear;
	    		
	    		
	    	}
	    	//Check if the paymentData object is empty if it is there
	    	//was a problem validating the formdata so don't post
	    	if(!$.isEmptyObject(paymentData)) {
	    		ajaxModular.ajax_update_state({
	     	        method: 'POST',
	     	        url: '/AjaxRegisterCostcoPayUserCmd',
	     	        data: paymentData,
	     	        dataType: 'json',
	     	        done: function (data, textStatus, jqXHR, options) {
	     	        	if(!data.errorMessage) {
	     	        		ajaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
	     	        		//If we are sucessfull in registering the account lets get the fobs
	     	        		if(typeof CostcoPayAccountInformation.getCostcoPayUserId() !== 'undefined') {
	    	     	        	COSTCO.CostcoPayFob.getCostcoPayFobs();
	    	     	         }
	     	        	}
	     	        	else {
	     	        		let errorCont = $('#register-crit-notification');
	     	        		errorCont.text(data.errorMessage);
	     	        		errorCont.removeClass('hide');
	     	        	}
	     	        },
	     	        always: function() {
	     	            $('#costco-pay-payment-method').removeClass('ajax-busy');
	     	            $('#costco-pay-notification').removeClass('ajax-busy');
	     	           TokenGateway.refreshGateway();
	     	        },
	 	    	 });
	    	}
	    },
	    /**
	     * funtion used that bind to the save card button this will invoke the proper 
	     * function to be used to send the ajax call in the back
	     */
	    saveCard: function(form) {
	    	$form = $(form);
	    	let expDate = $form.find('input[name=cc_expiry_date]').val().split('/');
	    	
	    	$form.find('input[name=expireMonth]').val(expDate[0]);
	    	$form.find('input[name=expireYear]').val('20' + expDate[1]);
	    	TokenGateway.updateSessionFromForm('card', 
	    		function() {
	    			if($form.find('#costcoPayUserId').val() != '')
	    				CostcoPayAccountInformation.ajaxManageCostcoPayPayment();
	    			else
	    				CostcoPayAccountInformation.ajaxRegisterCostcoPayUser();
	    		}
	    	, $form.attr('id'));
	    },
	    /**
	     * function used to bind to the editCard button, will transform the current display
	     * payment method form to the edit mode
	     */
	    editCard: function() {
	    	let template = COSTCO.util.tmpl('tmpl_edit_payment_method',costcoPayPaymentObject);
	    	$('#costco-pay-payment-method-display').hide();
	    	$('#register-card-on-file-button').hide();
	    	$('#costco-pay-payment-method-edit').html(template);
	    	COSTCO.util.accesible_popover($('.co-info, .co-help'));
	    	this.maskInput();
	        createTokenSessionId();

	    	TokenGateway.refreshGateway();
	    },
	    /**
	     * Function used to show the add card form when the user wants
	     * to add a new card instead of their saved payment method
	     */
	    addCard: function() {
	    	let addCardObject = costcoPayPaymentObject;
	    	addCardObject.eprAccountUserId='';
	    	addCardObject.eprAccountUserId='';
	    	addCardObject.cardType='';
	    	addCardObject.cardNumber='';
	    	addCardObject.cardHolderName='';
	    	addCardObject.cardExpireMonth='';
	    	addCardObject.cardExpireYear='';
	    	let template = COSTCO.util.tmpl('tmpl_edit_payment_method',addCardObject);
	    	$('#costco-pay-payment-method-display').hide();
	    	$('#register-card-on-file-button').hide();
	    	$('#costco-pay-payment-method-edit').html(template);
	    	COSTCO.util.accesible_popover($('.co-info, .co-help'));
	    	this.maskInput();
	    },
	    /**
	     * function to open the confirmation dialog box when user wants to remove their
	     * costcoapay payment method
	     */
	    deleteCard: function() {
	    	let authTokenId = costcoPayPaymentObject.authToken;
	    	let costcoPayUserId = costcoPayPaymentObject.costcoPayUserId;
	    	COSTCO.dialog.createExtDialogBox({
	    		title:messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_TITLE,
	    		body: messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_BODY,
	    		primary: messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_PRIMARY,
	    		secondary: messages.COSTCO_PAY_PAYMENT_REMOVE_MODAL_SECONDARY,
	    		primary_event: function() {
	    			ajaxModular.ajax_update_state({
	         	        method: 'POST',
	         	        url: '/AjaxManageCostcoPayPaymentCmd',
	         	        data: {'authTokenId': authTokenId, 
	         	        	   'costcoPayUserId':costcoPayUserId,
	         	        	   'action': 'delete'},
	         	        dataType: 'json',
	         	        
	         	        done: function(data, textStatus, jqXHR, options) {
	         	          ajaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
	         	          COSTCO.util.accesible_popover($('.co-info, .co-help'));
	         	         if(typeof CostcoPayAccountInformation.getCostcoPayUserId() !== 'undefined') {
    	     	        	COSTCO.CostcoPayFob.getCostcoPayFobs();
    	     	         }
	         	          COSTCO.dialog.close();
	         	        },
	         	        always: function() {
	         	            $('.order-ajax').removeClass('ajax-busy');
	         	        },
	     	    	}); 
	    		}
	    	});
	    }
	}
	window.COSTCO.CostcoPayAccountInformation = CostcoPayAccountInformation;
	return CostcoPayAccountInformation;
});


// WEBPACK FOOTER //
// ./js/account/costcopay-account-information.js